import React, { useState, useMemo, useEffect, useCallback } from "react";
import {
  Card,
  Spin,
  Radio,
  Tabs,
  Space,
  Button,
  Form,
  message,
  Typography,
  Alert,
  Upload,
} from "antd";
import {
  ArrowLeftOutlined,
  FileTextOutlined,
  CloseOutlined,
  CheckCircleOutlined,
  CalendarOutlined,
  CloseCircleOutlined,
  TeamOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

// Components
import FormJudge1 from "../componentsJudgment/FormJudge1";
import FormJudge2 from "../componentsJudgment/FormJudge2";
import FormPostponed from "../componentsJudgment/FormPostponed";
import FormWithdrawAccusation from "../componentsJudgment/FormWithdrawAccusation";
import AddDefendantModal from "../modalJudgment/AddDefendantModal";

// Hooks
import useJudgmentData from "../hooks/useJudgmentData";

// Constants
import Compressor from "compressorjs";

const { Title, Text } = Typography;

const CreateJudgment = ({
  dataDefault,
  onClose,
  funcUpdateStatus,
  dataDB2,
}) => {
  const [form] = Form.useForm();
  const [formAddDefendant] = Form.useForm();
  const roleId = localStorage.getItem("ROLE_ID");

  // Custom Hook
  const {
    loading,
    setLoading,
    dataLoadGurantor,
    checkboxTab1,
    checkboxTab2,
    allDefendants,
    guarantorsOnly,
    customerCustomerId,
    customerCustomerIdAll,
    nextGarno,
    userId,
    loadGurantor,
    postStatus,
    addCustomerJudge,
    handleCheckboxTab1Change,
    handleCheckboxTab2Change,
    resetCheckboxes,
    saveFormDataTab1,
    getMergedFormData,
    formDataTab1,
    resetFormDataTab1,
    selectedDefendantsTab1,
    selectedDefendantsTab2,
    handleUpLoadIMG,
  } = useJudgmentData({ dataDefault, form });

  // Local States
  const [defaultRadio, setDefaultRadio] = useState("normal");
  const [radioDecide, setRadioDecide] = useState(null);
  const [radioFinish, setRadioFinish] = useState(null);
  const [tabsKey, setTabsKey] = useState("1");
  const [fileList, setFileList] = useState([]);
  const [isModalAddDefendant, setIsModalAddDefendant] = useState(false);
  const [arrow, setArrow] = useState("Show");
  // ✅ เพิ่ม State สำหรับจัดการรูปภาพ
  const [allImg, setAllImg] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  console.log("defaultRadio", defaultRadio);
  console.log("radioDecide", radioDecide);
  console.log("radioFinish", radioFinish);
  console.log("loanDataDB2", dataDB2);
  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") return false;
    if (arrow === "Show") return true;
    return { pointAtCenter: true };
  }, [arrow]);

  // ✅ คำนวณ disabled defendants สำหรับแต่ละ Tab
  const disabledDefendantsTab1 = useMemo(() => {
    // Tab1 ไม่สามารถเลือกคนที่ถูกเลือกใน Tab2 แล้ว
    return checkboxTab2;
  }, [checkboxTab2]);

  const disabledDefendantsTab2 = useMemo(() => {
    // Tab2 ไม่สามารถเลือกคนที่ถูกเลือกใน Tab1 แล้ว
    return checkboxTab1;
  }, [checkboxTab1]);

  // ========================================
  // Auto-check ผู้เช่าซื้อใน Tab 1
  // ========================================

  useEffect(() => {
    if (customerCustomerId) {
      if (!checkboxTab1.includes(customerCustomerId)) {
        handleCheckboxTab1Change([...checkboxTab1, customerCustomerId]);
      }
    }
  }, [customerCustomerId, checkboxTab1, handleCheckboxTab1Change]);

  const onChangeCheckBoxAll = useCallback(
    (e) => {
      const value = e.target.checked;
      resetCheckboxes();
      if (radioDecide === "agreement" && value) {
        handleCheckboxTab1Change(customerCustomerIdAll);
      } else {
        handleCheckboxTab1Change([customerCustomerId]);
      }
    },
    [
      radioDecide,
      customerCustomerIdAll,
      customerCustomerId,
      resetCheckboxes,
      handleCheckboxTab1Change,
    ],
  );

  // ========================================
  // Event Handlers
  // ========================================

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  const onFinish = useCallback(
    async (values) => {
      try {
        console.log("Form Values:", values);
        console.log("Selected Defendants Tab1:", selectedDefendantsTab1);
        console.log("Selected Defendants Tab2:", selectedDefendantsTab2);
        console.log("Radio Decide:", radioDecide);

        let payload;
        let loanNewData;
        let judgeDefData = [];
        const newContno = dataDefault.CONTNO.includes("-")
          ? "V" + dataDefault.CONTNO
          : "V-" + dataDefault.CONTNO;
        console.log("newContno", newContno);

        // ========================================
        // สร้าง payload ตามประเภทการทำรายการ
        // ========================================
        if (defaultRadio === "postponed") {
          payload = {
            currentStatus: 5,
            loanId: dataDefault.loanId,
            lawsuitId: dataDefault.lawsuitId,
            considerationDate: dayjs(values.considerationDate).format(),
            mark: values.memo,
            userId: userId,
          };
        } else if (defaultRadio === "withdrawCase") {
          payload = {
            currentStatus: 8,
            loanId: dataDefault.loanId,
            lawsuitId: dataDefault.lawsuitId,
            withdrawCaseDate: dayjs(values.withdrawCaseDate).format(),
            mark: values.memo,
            userId: userId,
          };
        } else {
          // กรณี enforce

          if (radioDecide === "enforce") {
            // Tab1
            if (
              selectedDefendantsTab1?.length > 0 &&
              (formDataTab1 || values)
            ) {
              selectedDefendantsTab1.forEach((defendant) => {
                const isCustomer = defendant.type === "customer";

                let costInterestLimit = 0;
                if (values?.delayCostUnless1) {
                  if (values?.costUnless1 && values?.delayCostUnless1) {
                    costInterestLimit = Math.round(
                      ((formDataTab1?.costUnless1 || values?.costUnless1) *
                        (formDataTab1?.interestRateCostUnless1 ||
                          values.interestRateCostUnless1) *
                        (formDataTab1?.delayCostUnless1 ||
                          formDataTab1?.delayCostUnless1)) /
                        365,
                    );
                  }
                }
                let tab1Data;
                if (formDataTab1) {
                  tab1Data = {
                    loanId: dataDefault.loanId,
                    lawsuitId: dataDefault.lawsuitId,
                    CONTNO: dataDefault.CONTNO,
                    customerId: defendant.CUSTOMER_ID,
                    judgeNumber: 1,
                    defendantNumber: defendant.garno + 1,
                    newContno: newContno,
                    ref: isCustomer ? "001" : "002",
                    TONBALANCE: formDataTab1.judgementLack1
                      ? formDataTab1.judgementLack1
                      : formDataTab1.judgement1,
                    interestRate:
                      formDataTab1.interestRate1 * 100 ||
                      formDataTab1.interestRateJudgeLack1 * 100,
                    interestLimit: 0,
                    delay: 0,
                    firstDate: formDataTab1.dateInterest1
                      ? dayjs(formDataTab1.dateInterest1).format()
                      : null,

                    costOfUselesenessPerMonth: formDataTab1.costPermonth1 || 0,
                    costOfUselessness: formDataTab1.costUnless1 || 0,
                    costRate: formDataTab1.interestRateCostUnless1 * 100 || 0,
                    costInterestLimit: costInterestLimit,
                    costDelay: formDataTab1.delayCostUnless1 || null,
                    costFirstDate: formDataTab1.dateInterestCostUnless1
                      ? dayjs(formDataTab1.dateInterestCostUnless1).format()
                      : null,
                    costSdatePerMonth: formDataTab1.datePermonthInterest1
                      ? dayjs(formDataTab1.datePermonthInterest1).format()
                      : null,
                    costOfUselesenessMonth: formDataTab1.costDay1 || 0,

                    trackingFee: formDataTab1.trackingFeeEnforce1 || 0,
                    attorneyFees: formDataTab1.lawyerFeeEnforce1 || 0,
                    fee: parseInt(formDataTab1.courtFee1) || 0,
                  };
                } else {
                  tab1Data = {
                    loanId: dataDefault.loanId,
                    lawsuitId: dataDefault.lawsuitId,
                    CONTNO: dataDefault.CONTNO,
                    customerId: defendant.CUSTOMER_ID,
                    judgeNumber: 1,
                    defendantNumber: defendant.garno + 1,
                    newContno: newContno,
                    ref: isCustomer ? "001" : "002",
                    TONBALANCE: values.judgementLack1
                      ? values.judgementLack1
                      : values.judgement1,
                    interestRate:
                      values.interestRate1 * 100 ||
                      values.interestRateJudgeLack1 * 100,
                    interestLimit: 0,
                    delay: 0,
                    firstDate: values.dateInterest1
                      ? dayjs(values.dateInterest1).format()
                      : null,

                    costOfUselesenessPerMonth: values.costPermonth1 || 0,
                    costOfUselessness: values.costUnless1 || 0,
                    costRate: values.interestRateCostUnless1 * 100 || 0,
                    costInterestLimit: costInterestLimit || 0,
                    costDelay: values.delayCostUnless1 || 0,
                    costFirstDate: values.dateInterestCostUnless1
                      ? dayjs(values.dateInterestCostUnless1).format()
                      : null,
                    costSdatePerMonth: values.datePermonthInterest1
                      ? dayjs(values.datePermonthInterest1).format()
                      : null,
                    costOfUselesenessMonth: values.costDay1 || null,

                    trackingFee: values.trackingFeeEnforce1 || 0,
                    attorneyFees: values.lawyerFeeEnforce1 || 0,
                    fee: parseInt(values.courtFee1) || 0,
                  };
                }

                console.log("tab1Data", tab1Data);

                judgeDefData.push(tab1Data);
              });
            }

            // Tab2
            if (selectedDefendantsTab2 && selectedDefendantsTab2.length > 0) {
              selectedDefendantsTab2.forEach((defendant) => {
                const isCustomer = defendant.type === "customer";

                let interestLimit2 = null;
                if (values.delayJudgement2) {
                  if (values.judgementLack2 && values.interestRateLack2) {
                    interestLimit2 = Math.round(
                      (values.judgementLack2 *
                        values.interestRateLack2 *
                        values.delayJudgement2) /
                        365,
                    );
                  } else if (values.judgement2 && values.interestRate2) {
                    interestLimit2 = Math.round(
                      (values.judgement2 *
                        values.interestRate2 *
                        values.delayJudgement2) /
                        365,
                    );
                  }
                }

                let costInterestLimit2 = null;
                if (values.delayCostUnless2) {
                  if (values.costUnless2 && values.delayCostUnless2) {
                    costInterestLimit2 = Math.round(
                      (values.costUnless2 *
                        values.interestRateCostUnless2 *
                        values.delayCostUnless2) /
                        365,
                    );
                  }
                }

                const tab2Data = {
                  loanId: dataDefault.loanId,
                  lawsuitId: dataDefault.lawsuitId,
                  CONTNO: dataDefault.CONTNO,
                  customerId: defendant.CUSTOMER_ID,
                  judgeNumber: 2,
                  defendantNumber: defendant.garno + 1,
                  newContno: newContno,
                  ref: isCustomer ? "001" : "002",
                  TONBALANCE: values.judgementLack2
                    ? values.judgementLack2
                    : values.judgement2,
                  interestRate: values.interestRateLack2
                    ? values.interestRateLack2 * 100
                    : values.interestRate2
                      ? values.interestRate2 * 100
                      : 0,
                  interestLimit: interestLimit2 || 0,
                  delay: values.delayJudgement2 || null,
                  firstDate: values.dateInterest2
                    ? dayjs(values.dateInterest2).format()
                    : null,
                  costOfUselesenessPerMonth: values.costPermonth2 || 0,
                  costOfUselessness: values.costUnless2 || 0,
                  costRate: values.interestRateCostUnless2 * 100 || 0,
                  costInterestLimit: costInterestLimit2 || 0,
                  costDelay: values.delayCostUnless2 || null,
                  costFirstDate: values.dateInterestCostUnless2
                    ? dayjs(values.dateInterestCostUnless2).format()
                    : null,
                  costSdatePerMonth: values.datePermonthInterest2
                    ? dayjs(values.datePermonthInterest2).format()
                    : null,
                  costOfUselesenessMonth: values.CostUnlessDay2 || null,
                  trackingFee: values.trackingFeeEnforce2 || 0,
                  attorneyFees: values.lawyerFeeEnforce2 || 0,
                  fee: parseInt(values.courtFee2) || 0,
                };
                judgeDefData.push(tab2Data);
              });
            }

            console.log("ไม่เท่ากัน", judgeDefData);
          } else {
            allDefendants.forEach((defendant) => {
              const isCustomer = defendant.type === "customer";
              const isCustomerId = defendant.CUSTOMER_ID;

              const allPayData = {
                loanId: dataDefault.loanId,
                lawsuitId: dataDefault.lawsuitId,
                CONTNO: dataDefault.CONTNO,
                customerId: isCustomerId,
                judgeNumber: 1,
                defendantNumber: defendant.garno + 1,
                newContno: newContno,
                ref: isCustomer ? "001" : "002",

                TONBALANCE: parseFloat(values.paymentDue),
                interestRate:
                  radioDecide === "enforce"
                    ? values.interestRate1 * 100 ||
                      values.interestRateJudgeLack1 * 100
                    : 0,
                interestLimit: 0,
                delay: null,
                firstDate: values.dateInterest1
                  ? dayjs(values.dateInterest1).format()
                  : null,
                costOfUselesenessPerMonth: values.costPermonth1 || 0,
                costOfUselessness: values.costUnless1 || 0,
                costRate: values.interestRateCostUnless1 * 100 || 0,
                costInterestLimit: 0,
                costDelay: values.delayCostUnless1 || null,
                costFirstDate: values.dateInterestCostUnless1
                  ? dayjs(values.dateInterestCostUnless1).format()
                  : null,
                costSdatePerMonth: values.datePermonthInterest1
                  ? dayjs(values.datePermonthInterest1).format()
                  : null,
                costOfUselesenessMonth: values.costDay1 || null,

                trackingFee: values.trackingFeeEnforce1 || 0,
                attorneyFees: values.lawyerFeeEnforce1 || 0,
                fee: parseInt(values.courtFee1) || 0,

                defendantName: `${defendant.SNAM}${defendant.NAME1} ${defendant.NAME2}`,
                defendantType: defendant.type,
                garno: defendant.garno,
              };

              judgeDefData.push(allPayData);
            });
            const customerId = allDefendants.find(
              (item) => item.type === "customer",
            )?.CUSTOMER_ID;

            loanNewData = {
              // เพิ่ม loan_new มา
              CUSTOMER_ID: customerId,
              NEW_CONTNO: newContno,
              ISSUNO: dataDefault.CONTNO,
              SDATE: dayjs(values.enforceCaseDate).format(), // น่าจะใส่วันพิพากษา
              FDATE: dayjs(values.dueDate).format(), // วันดิวแรก
              LDATE: dayjs(values.dueDate)
                .add(values.costMonth3 - 1, "month")
                .format(), // วันดิวสุดท้าย
              TOT_UPAY: values.paymentPerMonthAmount, // ค่างวด
              T_NOPAY: values.costMonth3, // จำนวนงวด
              NCSHPRC: values.paymentDue, // ยอด
              LOCAT: null, // สาขา ไม่ใส่ก็ได้ แล้วแต่
            };

            console.log("ทำยอม:", judgeDefData);
            console.log("allDefendants", allDefendants);
          }

          let definedCostPermonthValue = 0;
          if (formDataTab1?.costPermonth1 ?? values?.costPermonth1) {
            if (formDataTab1?.costDay1 ?? values?.costDay1 ?? 1) {
              definedCostPermonthValue =
                (formDataTab1?.costPermonth1 ?? values?.costPermonth1) *
                (formDataTab1?.costDay1 ?? values?.costDay1 ?? 1);
            } else {
              definedCostPermonthValue =
                (formDataTab1?.costPermonth1 ?? values?.costPermonth1) * 1;
            }
          }

          // สร้าง payload หลัก
          payload = {
            currentStatus:
              radioDecide === "enforceAllPay" || radioDecide === "enforce"
                ? 9
                : 10,
            loanId: dataDefault.loanId,
            lawsuitId: dataDefault.lawsuitId,
            userId: userId,
            CONTNO: dataDefault.CONTNO,
            mark: values.memo || null,
            redCaseNumber: values.redNumber,
            judgeDate: dayjs(values.enforceCaseDate).format(),

            judgement: values.judgement1,
            judgeInterestRate: values.interestRate1 * 100 || 0,

            judgementLack: values.judgementLack1 || 0,
            interestRate:
              values.interestRate1 * 100 || values.interestRateJudgeLack1 * 100,

            lackOfBenefits: values.costUnless1 || 0,
            interestRateOfLack: values.interestRateCostUnless1 * 100 || 0,
            LACK_BALANCE: values.costUnless1 || 0,

            fee: parseInt(values.courtFee1) || 0,
            trackingFee: values.trackingFeeEnforce1 || 0,
            attorneyFees: values.lawyerFeeEnforce1 || 0,

            copyingFee: 0,
            trialMoneyCleared: 0,
            suspensionAmount: 0,

            AROTHR:
              radioDecide === "agreement"
                ? 0
                : parseFloat(values.courtFee1 || 0) +
                  parseFloat(values.trackingFeeEnforce1 || 0) +
                  parseFloat(values.lawyerFeeEnforce1 || 0) +
                  definedCostPermonthValue,
            TONBALANCE:
              radioDecide === "agreement"
                ? parseFloat(values.paymentDue)
                : parseFloat(values.judgementLack1 || 0)
                  ? parseFloat(values.judgementLack1 || 0)
                  : parseFloat(values.judgement1 || 0),
            judgementInterest:
              parseFloat(values.judgementLack1 || 0) > 0 &&
              parseFloat(values.judgement1 || 0) >
                parseFloat(values.judgementLack1 || 0)
                ? Math.round(
                    parseFloat(values.judgement1 || 0) -
                      parseFloat(values.judgementLack1 || 0),
                  )
                : 0,

            //เพิ่ม
            creditPercen:
              dataDB2?.MORTGAGE?.TYPE === "เงินกู้" ||
              dataDB2?.MORTGAGE?.TYPE === "เงินกู้" ||
              dataDB2?.MORTGAGE?.BABB === "เงินกู้" ||
              dataDB2?.MORTGAGE?.COLOR === "เงินกู้"
                ? 25
                : dataDefault.product === 1 || dataDefault.product === 3
                  ? 25
                  : 70,
            creditDebtor:
              radioDecide === "agreement"
                ? Math.round(
                    (parseFloat(values.judgement1 || 0) +
                      parseFloat(values.costUnless1 || 0) +
                      definedCostPermonthValue) *
                      ((dataDB2?.MORTGAGE?.TYPE === "เงินกู้" ||
                      dataDB2?.MORTGAGE?.TYPE === "เงินกู้" ||
                      dataDB2?.MORTGAGE?.BABB === "เงินกู้" ||
                      dataDB2?.MORTGAGE?.COLOR === "เงินกู้"
                        ? 25
                        : dataDefault.product === 1 || dataDefault.product === 3
                          ? 25
                          : 70) /
                        100),
                  )
                : Math.round(
                    (parseFloat(values.judgement1 || 0) +
                      parseFloat(values.costUnless1 || 0) +
                      parseFloat(values.courtFee1 || 0) +
                      parseFloat(values.trackingFeeEnforce1 || 0) +
                      parseFloat(values.lawyerFeeEnforce1 || 0) +
                      definedCostPermonthValue) *
                      ((dataDB2?.MORTGAGE?.TYPE === "เงินกู้" ||
                      dataDB2?.MORTGAGE?.TYPE === "เงินกู้" ||
                      dataDB2?.MORTGAGE?.BABB === "เงินกู้" ||
                      dataDB2?.MORTGAGE?.COLOR === "เงินกู้"
                        ? 25
                        : dataDefault.product === 1 || dataDefault.product === 3
                          ? 25
                          : 70) /
                        100),
                  ),
            judgeDef: judgeDefData,
            loanNew: loanNewData ? loanNewData : null,
          };
        }

        console.log("📦 Payload:", payload);

        setLoading(true);
        const result = await postStatus(payload);

        if (result !== 200) {
          throw new Error("ไม่สามารถบันทึกข้อมูลได้");
        }

        console.log("✅ ขั้นตอนที่ 1: บันทึกข้อมูลคำพิพากษาสำเร็จ");
        if (allImg && allImg.length > 0 && defaultRadio !== "postponed") {
          try {
            console.log(
              `📤 ขั้นตอนที่ 2: กำลังอัปโหลดรูปภาพ ${allImg.length} ไฟล์...`,
            );

            const uploadData = {
              id: dataDefault.loanId,
            };

            const uploadResult = await handleUpLoadIMG(allImg, 6, uploadData);

            if (uploadResult === 200) {
              console.log("✅ ขั้นตอนที่ 2: อัปโหลดรูปภาพสำเร็จ");
            }
          } catch (uploadError) {
            console.error("❌ อัปโหลดรูปภาพล้มเหลว:", uploadError);
            message.warning({
              content: "บันทึกข้อมูลสำเร็จ แต่อัปโหลดรูปภาพล้มเหลว",
              duration: 4,
            });
            // ไม่ throw error เพื่อให้ดำเนินการต่อได้
          }
        } else {
          console.log("ℹ️ ไม่มีรูปภาพที่ต้องอัปโหลด");
        }

        // ========================================
        // ✅ ขั้นตอนที่ 3: อัปเดทสถานะหน้าหลัก
        // ========================================
        if (funcUpdateStatus) {
          try {
            console.log("🔄 ขั้นตอนที่ 3: กำลังอัปเดทสถานะ...");
            await funcUpdateStatus();
            console.log("✅ ขั้นตอนที่ 3: อัปเดทสถานะสำเร็จ");
          } catch (updateError) {
            console.error("❌ อัปเดทสถานะล้มเหลว:", updateError);
            // ไม่ throw error เพราะข้อมูลหลักบันทึกสำเร็จแล้ว
          }
        }

        // ========================================
        // ✅ ขั้นตอนที่ 4: แสดง Success Message และปิดหน้าต่าง
        // ========================================
        message.success({
          content: "บันทึกคำพิพากษาสำเร็จ",
          duration: 2,
        });

        // Delay เล็กน้อยเพื่อให้ user เห็น success message
        setTimeout(() => {
          handleCancel();
        }, 500);
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);

        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง";

        message.error({
          content: errorMessage,
          duration: 4,
        });
      } finally {
        setLoading(false);
      }
    },
    [
      defaultRadio,
      radioDecide,
      dataDefault,
      userId,
      selectedDefendantsTab1,
      selectedDefendantsTab2,
      allDefendants,
      postStatus,
      funcUpdateStatus,
      handleCancel,
      allImg,
      handleUpLoadIMG,
      setLoading,
      formDataTab1,
    ],
  );
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบถ้วน");
  };

  const onChangeJudgement = (value) => {
    form.setFieldsValue({ paymentDue: value });
  };

  const onChange = (e) => {
    setDefaultRadio(e.target.value);
    form.setFieldsValue({
      memo: null,
      wishes: null,
      governmentOfficer1: [],
      governmentOfficer2: [],
      actionType: null,
    });
    setRadioDecide(null);
    setRadioFinish(null);
    setFileList([]);
    resetCheckboxes();
    resetFormDataTab1();
  };

  const onChangeDecide = (e) => {
    const value = e.target.value;

    if (!dataLoadGurantor) {
      loadGurantor();
    }
    setRadioDecide(value);
    if (value === "agreement" || value === "enforceAllPay") {
      setTabsKey("1");
    }

    resetFormDataTab1();
  };

  const onChangeDate = (date, dateString) => {
    console.log(date, dateString);
  };

  const onChangeDateAgreement = (date, dateString) => {
    console.log(date, dateString);
  };

  const handleTabChange = useCallback((key) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    setTabsKey(key);
  }, []);

  // ========================================
  // Modal Handlers
  // ========================================

  const handleOpenAddDefendant = () => {
    setIsModalAddDefendant(true);
    formAddDefendant.resetFields();
  };

  const handleAddDefendant = async () => {
    try {
      const values = await formAddDefendant.validateFields();
      await addCustomerJudge(values);
      setIsModalAddDefendant(false);
      formAddDefendant.resetFields();
    } catch (error) {
      console.log("Add defendant failed:", error);
    }
  };

  // ✅ Helper function สำหรับ compress รูป
  const compressImage = async (file, types, index) => {
    return new Promise((resolve) => {
      let quality;
      if (file.size >= 2500000) quality = 0.1;
      else if (file.size >= 2000000) quality = 0.15;
      else if (file.size >= 1500000) quality = 0.2;
      else if (file.size >= 1000000) quality = 0.3;
      else quality = 0.5;

      new Compressor(file, {
        quality: quality,
        success: (result) => {
          const fileOptions = {
            type: result.type,
            lastModified: Date.now(),
          };
          const compressedFileAsFile = new File(
            [result],
            file.name,
            fileOptions,
          );

          const image = {
            imageCompressedFile: compressedFileAsFile,
            type: types,
            originalIndex: index,
          };

          setAllImg((prev) => [...prev, image]);
          setLoading(false);
          resolve(true);
        },
        error: (err) => {
          console.error("Compressor error:", err);
          message.error(`ไม่สามารถบีบอัดไฟล์ "${file.name}" ได้`);
          setLoading(false);
          resolve(true);
        },
      });
    });
  };

  // ✅ Preview รูป
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
      let pdfUrl = file.url;
      if (!pdfUrl && file.originFileObj) {
        pdfUrl = URL.createObjectURL(file.originFileObj);
      }
      window.open(pdfUrl, "_blank");
      return;
    }

    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  // ✅ Handle change file list
  const handleChangeIMG = ({ fileList: newFileList, file }) => {
    const updatedFileList = newFileList.map((f) => {
      if (f.type === "application/pdf" || f.name.endsWith(".pdf")) {
        // Custom icon logic ถ้าต้องการ
      }
      return f;
    });

    setFileList(updatedFileList);

    if (file.status === "removed") {
      setAllImg((prevAllImg) => {
        return prevAllImg.filter((img) => img.originalIndex !== file.uid);
      });
    }

    if (
      file.status === "done" ||
      file.status === "removed" ||
      file.status === "error"
    ) {
      setLoading(false);
    }
  };

  // ✅ Before upload
  const beforeUpts = async (file, ty) => {
    const isPdf =
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf");

    if (isPdf) {
      const image = {
        imageCompressedFile: file,
        type: ty,
        originalIndex: file.uid,
      };
      setAllImg((prev) => [...prev, image]);
      return false;
    }

    if (file.size > 5000000) {
      message.warning(`ไฟล์ "${file.name}" เกิน 5MB`);
      return Upload.LIST_IGNORE;
    }

    try {
      setLoading(true);
      await compressImage(file, ty, file.uid);
      return false;
    } catch (error) {
      console.error("File processing error:", error);
      message.error("File processing failed.");
      return Upload.LIST_IGNORE;
    }
  };

  // ✅ Upload Props
  const uploadProps = {
    name: "file",
    multiple: true,
    accept: "image/*,.pdf",
    listType: "picture",
    fileList: fileList,
    onPreview: handlePreview,
    onChange: handleChangeIMG,
    beforeUpload: (file) =>
      beforeUpts(
        file,
        defaultRadio === "normal"
          ? radioDecide === "enforceAllPay"
            ? 6
            : radioDecide === "enforce"
              ? 7
              : 8
          : 9,
      ),
    iconRender: (file) => {
      if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
        return (
          <FilePdfOutlined style={{ fontSize: "48px", color: "#ff4d4f" }} />
        );
      }
      return null;
    },
  };

  // ========================================
  // Tabs Configuration
  // ========================================

  const tabItems = useMemo(() => {
    const items = [
      {
        key: "1",
        label: (
          <span style={{ fontSize: 16 }}>
            {radioDecide === "enforce"
              ? "คำพิพากษาจำเลยที่ ๑"
              : "คำพิพากษาจำเลย"}
          </span>
        ),
        children: (
          <FormJudge1
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            onChangeDate={onChangeDate}
            onChangeJudgement={onChangeJudgement}
            onChangeDateAgreement={onChangeDateAgreement}
            uploadProps={uploadProps}
            radioDecide={radioDecide}
            radioFinish={radioFinish}
            dataDefault={dataDefault}
            checkboxTab1={checkboxTab1}
            allDefendants={allDefendants}
            customerCustomerId={customerCustomerId}
            handleCheckboxTab1Change={handleCheckboxTab1Change}
            onAddDefendantClick={handleOpenAddDefendant}
            handleCancel={handleCancel}
            setTabsKey={setTabsKey}
            loading={loading}
            mergedArrow={mergedArrow}
            saveFormDataTab1={saveFormDataTab1}
            disabledDefendants={disabledDefendantsTab1} // ✅ เพิ่ม
            allImg={allImg} // ✅ เพิ่ม
            handleUpLoadIMG={handleUpLoadIMG} // ✅ เพิ่ม
            onChangeCheckBoxAll={onChangeCheckBoxAll}
          />
        ),
      },
    ];

    if (
      (dataDefault.LAW_TYPE_ID !== 2 || dataDefault.LAW_TYPE_ID !== 5) &&
      radioDecide === "enforce"
    ) {
      items.push({
        key: "2",
        label: <span style={{ fontSize: 16 }}>คำพิพากษาจำเลยถัดไป</span>,
        disabled: true,
        children: (
          <FormJudge2
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            onChangeDate={onChangeDate}
            checkboxTab2={checkboxTab2}
            guarantorsOnly={guarantorsOnly}
            handleCheckboxTab2Change={handleCheckboxTab2Change}
            onAddDefendantClick={handleOpenAddDefendant}
            handleCancel={handleCancel}
            setTabsKey={setTabsKey}
            loading={loading}
            mergedArrow={mergedArrow}
            getMergedFormData={getMergedFormData}
            formDataTab1={formDataTab1}
            disabledDefendants={disabledDefendantsTab2} // ✅ เพิ่ม
          />
        ),
      });
    }

    return items;
  }, [
    radioDecide,
    form,
    onFinish,
    onFinishFailed,
    uploadProps,
    radioFinish,
    dataDefault,
    checkboxTab1,
    checkboxTab2,
    allDefendants,
    guarantorsOnly,
    customerCustomerId,
    handleCheckboxTab1Change,
    handleCheckboxTab2Change,
    loading,
    mergedArrow,
    saveFormDataTab1,
    getMergedFormData,
    formDataTab1,
    disabledDefendantsTab1,
    disabledDefendantsTab2,
    allImg,
    handleCancel,
    handleOpenAddDefendant,
    handleUpLoadIMG,
    onChangeCheckBoxAll,
    onChangeJudgement,
  ]);

  // ========================================
  // Render
  // ========================================

  return (
    <div
      style={{
        padding: "12px",
        maxWidth: 1400,
        margin: "0 auto",
        minHeight: "100vh",
        background: "#f0f2f5",
      }}
    >
      <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
        <Card
          title={
            <Space align="center" size="large">
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={handleCancel}
                type="text"
                size="large"
                style={{ fontSize: 16 }}
              >
                ย้อนกลับ
              </Button>
              <Title level={3} style={{ margin: 0 }}>
                {`บันทึกคำพิพากษา: ${dataDefault?.CONTNO || ""}`}
              </Title>
            </Space>
          }
          extra={
            <Button
              danger
              onClick={handleCancel}
              size="large"
              icon={<CloseOutlined />}
            >
              ปิด
            </Button>
          }
          variant={false}
          style={{
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            borderRadius: 12,
          }}
        >
          {/* Radio - ประเภทที่ทำรายการ */}
          <div style={{ marginBottom: 24 }}>
            <Text
              strong
              style={{ display: "block", marginBottom: 16, fontSize: 16 }}
            >
              <FileTextOutlined /> ประเภทที่ทำรายการ:
            </Text>
            <Radio.Group
              onChange={onChange}
              value={defaultRadio}
              size="large"
              buttonStyle="solid"
              style={{ display: "flex", gap: 12, flexWrap: "wrap" }}
            >
              <Radio.Button
                value="normal"
                style={{
                  height: 48,
                  lineHeight: "48px",
                  fontSize: 16,
                  minWidth: 180,
                  textAlign: "center",
                }}
              >
                <CheckCircleOutlined style={{ color: "green" }} /> ศาลตัดสิน
              </Radio.Button>
              <Radio.Button
                value="postponed"
                style={{
                  height: 48,
                  lineHeight: "48px",
                  fontSize: 16,
                  minWidth: 180,
                  textAlign: "center",
                }}
              >
                <CalendarOutlined style={{ color: "orange" }} />{" "}
                เลื่อนวันนัดพิจารณาคดี
              </Radio.Button>
              <Radio.Button
                value="withdrawCase"
                style={{
                  height: 48,
                  lineHeight: "48px",
                  fontSize: 16,
                  minWidth: 180,
                  textAlign: "center",
                }}
              >
                <CloseCircleOutlined style={{ color: "red" }} /> ถอนฟ้อง
              </Radio.Button>
            </Radio.Group>
          </div>

          {/* Radio - จำเลยประสงค์ */}
          {defaultRadio === "normal" && (
            <div style={{ marginBottom: 24 }}>
              <Text
                strong
                style={{ display: "block", marginBottom: 16, fontSize: 16 }}
              >
                <TeamOutlined /> จำเลยประสงค์:
              </Text>
              <Radio.Group
                onChange={onChangeDecide}
                value={radioDecide}
                size="large"
                buttonStyle="solid"
                style={{ display: "flex", gap: 12, flexWrap: "wrap" }}
              >
                <Radio.Button
                  value="enforce"
                  style={{
                    height: 48,
                    lineHeight: "48px",
                    fontSize: 16,
                    minWidth: 200,
                    textAlign: "center",
                  }}
                >
                  ⚖️ พิพากษา
                </Radio.Button>
                {/* <Radio.Button
                  value="enforceAllPay"
                  style={{
                    height: 48,
                    lineHeight: "48px",
                    fontSize: 16,
                    minWidth: 200,
                    textAlign: "center",
                  }}
                >
                  ⚖️ พิพากษา (เท่ากัน)
                </Radio.Button> */}
                <Radio.Button
                  value="agreement"
                  style={{
                    height: 48,
                    lineHeight: "48px",
                    fontSize: 16,
                    minWidth: 200,
                    textAlign: "center",
                  }}
                  // disabled
                >
                  🤝 ทำยอม (ประนีประนอม)
                </Radio.Button>
                {dataDefault.LAW_TYPE_ID === 11 ? (
                  <Radio.Button
                    value="preferentail_right"
                    style={{
                      height: 48,
                      lineHeight: "48px",
                      fontSize: 16,
                      minWidth: 200,
                      textAlign: "center",
                    }}
                  >
                    ⚖️ ขอรับชำระหนี้บุริมสิทธิ
                  </Radio.Button>
                ) : dataDefault.LAW_TYPE_ID === 12 ? (
                  <Radio.Button
                    value="average"
                    style={{
                      height: 48,
                      lineHeight: "48px",
                      fontSize: 16,
                      minWidth: 200,
                      textAlign: "center",
                    }}
                  >
                    📊 ขอรับเฉลี่ยทรัพย์
                  </Radio.Button>
                ) : null}
              </Radio.Group>
            </div>
          )}

          {/* Content */}
          {defaultRadio === "postponed" ? (
            <FormPostponed
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              onChangeDate={onChangeDate}
              handleCancel={handleCancel}
            />
          ) : defaultRadio === "normal" && radioDecide ? (
            <Tabs
              activeKey={tabsKey}
              onChange={handleTabChange}
              items={tabItems}
              size="large"
              centered
              tabBarStyle={{ marginBottom: 24 }}
              destroyOnHidden={false}
              disabled
            />
          ) : defaultRadio === "normal" ? (
            <Alert
              message="กรุณาเลือกประเภท 'จำเลยประสงค์'"
              description="เลือกว่าจำเลยประสงค์จะพิพากษาหรือทำยอม เพื่อดำเนินการต่อ"
              type="info"
              showIcon
              style={{ marginTop: 24 }}
            />
          ) : (
            <FormWithdrawAccusation
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              onChangeDate={onChangeDate}
              uploadProps={uploadProps}
              handleCancel={handleCancel}
            />
          )}
        </Card>
      </Spin>

      {/* Modal เพิ่มจำเลย */}
      <AddDefendantModal
        open={isModalAddDefendant}
        onCancel={() => {
          setIsModalAddDefendant(false);
          formAddDefendant.resetFields();
        }}
        onOk={handleAddDefendant}
        form={formAddDefendant}
        loading={loading}
        nextGarno={nextGarno}
        guarantorsLength={dataLoadGurantor?.guarantors?.length}
      />
    </div>
  );
};

export default CreateJudgment;
